<div class="background-gradient">
  <div class="background-gradient__image-wrapper">
    <img alt="background-image-player" class="background-gradient__player" height="1047" priority
         width="1183" [ngSrc]="'img/istra/background-image-1.png'">
    <img alt="background-image" class="background-gradient__image" height="1047" priority
         width="1183" [ngSrc]="'img/istra/background-image.jpg'">
  </div>
</div>

<div class="news-dashboard">
  <div class="news-dashboard__wrapper">
    <div class="news-dashboard__events">
      <app-new-all-events
        [eventsList]="eventsList"
        [title]="'TICKETS.UPCOMING_GAMES'"
        (selectEvent)="handleSelectEvent($event)"
      >
      </app-new-all-events>
    </div>

    <div class="news-dashboard__news">
      <app-small-card
        [icon]="'shopping_cart_outlined'"
        [imageSrc]="'img/istra/shop.jpg'"
        [title]="'COMMON.FAN_SHOP'"
        [url]="currentLang() === 'hr' ? 'https://shop.nkistra.com/hr/' : 'https://shop.nkistra.com/gb/'"
      />

      <app-small-card
        [icon]="'play_outlined'"
        [imageSrc]="'img/istra/novosti.jpg'"
        [title]="'COMMON.NEWS'"
        [url]="currentLang() === 'hr' ? 'https://nkistra.com/novosti/' : 'https://nkistra.com/en/news/'"
      />
    </div>
  </div>
</div>
